/**
 * Hero Rotating Text Animation
 * Smoothly rotates through multiple phrases with fade effects
 */

class RotatingText {
  constructor(element) {
    this.element = element;
    this.textElement = element.querySelector('[data-phrases]');
    
    if (!this.textElement) return;
    
    // Get phrases from data attribute
    const phrasesData = this.textElement.getAttribute('data-phrases');
    this.phrases = phrasesData ? phrasesData.split('|').filter(p => p.trim()) : [];
    
    if (this.phrases.length <= 1) return;
    
    // Get animation speed from section
    const section = element.closest('.hero-animated-text');
    this.speed = section ? parseInt(section.getAttribute('data-animation-speed')) || 3500 : 3500;
    
    this.currentIndex = 0;
    this.isAnimating = false;
    
    // Check for reduced motion preference
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (!this.prefersReducedMotion) {
      this.start();
    }
  }
  
  start() {
    // Start rotation after initial display
    setTimeout(() => {
      this.rotate();
    }, this.speed);
  }
  
  rotate() {
    if (this.isAnimating) return;
    
    this.isAnimating = true;
    
    // Fade out current text
    this.textElement.classList.add('fade-out');
    
    setTimeout(() => {
      // Update to next phrase
      this.currentIndex = (this.currentIndex + 1) % this.phrases.length;
      this.textElement.textContent = this.phrases[this.currentIndex];
      
      // Fade in new text
      this.textElement.classList.remove('fade-out');
      this.textElement.classList.add('fade-in');
      
      setTimeout(() => {
        this.textElement.classList.remove('fade-in');
        this.isAnimating = false;
        
        // Schedule next rotation
        setTimeout(() => {
          this.rotate();
        }, this.speed);
      }, 500); // Match CSS transition duration
      
    }, 500); // Match CSS transition duration
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const rotatingElements = document.querySelectorAll('[data-rotating-text]');
  rotatingElements.forEach(element => {
    new RotatingText(element);
  });
});

// Re-initialize on Shopify section load (theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const rotatingElements = event.target.querySelectorAll('[data-rotating-text]');
    rotatingElements.forEach(element => {
      new RotatingText(element);
    });
  });
}
